import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable max-classes-per-file */
import * as localForage from 'localforage';
import { isBrowser } from './deploymentInfo';
var currentCacheVersion = 'biomage_0.0.1';
var previousCacheVersions = ['biomage'];
var deleteOldVersions = function deleteOldVersions() {
  var indexedDbInstace = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
  if (indexedDbInstace) {
    previousCacheVersions.forEach(function (db) {
      return indexedDbInstace.deleteDatabase(db);
    });
  }
};
var BrowserCache = /*#__PURE__*/function () {
  function BrowserCache() {
    _classCallCheck(this, BrowserCache);
    if (!BrowserCache.instance) {
      BrowserCache.instance = this;
    }
    this.maxSize = 300;
    this.size = 0;
    this.head = null;
    this.tail = null;
    this.lru = {};
    this.initialised = false;
  }
  _createClass(BrowserCache, [{
    key: "_init",
    value: function () {
      var _init2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;
        var length, keys;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!this.initialised) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              if (isBrowser) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              localForage.config({
                driver: localForage.INDEXEDDB,
                name: currentCacheVersion,
                storeName: 'biomage_cache',
                description: 'In Browser Cache'
              });
              _context.next = 8;
              return localForage.ready();
            case 8:
              _context.next = 10;
              return localForage.length();
            case 10:
              length = _context.sent;
              if (!length) {
                _context.next = 17;
                break;
              }
              _context.next = 14;
              return localForage.keys();
            case 14:
              keys = _context.sent;
              if (!this.tail) {
                // eslint-disable-next-line prefer-destructuring
                this.tail = keys[0];
              }
              keys.forEach(function (key) {
                _this._insert(key);
              });
            case 17:
              this.initialised = true;
              deleteOldVersions();
              _context.next = 24;
              break;
            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              console.trace(_context.t0);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 21]]);
      }));
      function _init() {
        return _init2.apply(this, arguments);
      }
      return _init;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var data, item;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return localForage.getItem(key);
            case 3:
              data = _context2.sent;
              if (data) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", data);
            case 6:
              item = data;
              if (!(item.ttl < Date.now())) {
                _context2.next = 11;
                break;
              }
              _context2.next = 10;
              return this.remove(key);
            case 10:
              return _context2.abrupt("return", null);
            case 11:
              if (this.head !== key) this._setHead(key);
              return _context2.abrupt("return", item.value);
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](0);
              console.trace(_context2.t0);
            case 18:
              return _context2.abrupt("return", null);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 15]]);
      }));
      function get(_x) {
        return _get.apply(this, arguments);
      }
      return get;
    }() // set value should not be used independently as it might cause cache poisoning
    // ttl is set to 12 hours by default
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, value) {
        var ttl,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              ttl = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 43200;
              if (!(this.size >= this.maxSize)) {
                _context3.next = 4;
                break;
              }
              _context3.next = 4;
              return this.remove(this.tail);
            case 4:
              if (ttl && typeof ttl === 'number') {
                // eslint-disable-next-line no-param-reassign
                ttl = Math.round(ttl * 1000 + Date.now());
              }
              _context3.prev = 5;
              _context3.next = 8;
              return localForage.setItem(key, {
                value: value,
                ttl: ttl
              });
            case 8:
              this._insert(key);
              if (!this.tail) {
                this.tail = key;
              }
              return _context3.abrupt("return", true);
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](5);
              console.trace(_context3.t0);
            case 16:
              return _context3.abrupt("return", false);
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[5, 13]]);
      }));
      function set(_x2, _x3) {
        return _set.apply(this, arguments);
      }
      return set;
    }()
  }, {
    key: "_insert",
    value: function _insert(key) {
      this.lru[key] = {
        next: null,
        previous: null
      };
      this.size += 1;
      var previousHead = this.head;
      this.head = key;
      if (previousHead) {
        this.lru[previousHead].next = key;
        this.lru[key].previous = previousHead;
      }
    }
  }, {
    key: "_setHead",
    value: function _setHead(key) {
      if (this.tail === key) {
        this.tail = this.lru[key].next;
      }
      if (this.lru[key]) {
        if (this.lru[key].next) {
          var next = this.lru[key].next;
          if (this.lru[next].previous) this.lru[next].previous = this.lru[key].previous;
        }
        if (this.lru[key].previous) {
          var previous = this.lru[key].previous;
          if (this.lru[previous].next) this.lru[previous].next = this.lru[key].next;
        }
        this.lru[key].next = null;
        this.lru[key].previous = null;
        var previousHead = this.head;
        this.head = key;
        if (previousHead) {
          this.lru[previousHead].next = key;
          this.lru[key].previous = previousHead;
        }
      } else {
        this._insert(key);
      }
    }
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key) {
        var _this$lru$key, _this$lru$key2;
        var next, previous, _next, _previous;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.tail === key) {
                if (this.lru[this.tail].next) {
                  next = this.lru[this.tail].next;
                  this.lru[next].previous = null;
                  this.tail = next;
                } else {
                  this.tail = null;
                }
                this.lru[key].next = null;
                this.lru[key].previous = null;
              }
              if (this.head === key) {
                if (this.lru[this.head].previous) {
                  previous = this.lru[this.head].previous;
                  this.lru[previous].next = null;
                  this.head = previous;
                } else {
                  this.head = null;
                }
                this.lru[key].next = null;
                this.lru[key].previous = null;
              }
              if ((_this$lru$key = this.lru[key]) !== null && _this$lru$key !== void 0 && _this$lru$key.next) {
                _next = this.lru[key].next;
                this.lru[_next].previous = this.lru[key].previous;
              }
              if ((_this$lru$key2 = this.lru[key]) !== null && _this$lru$key2 !== void 0 && _this$lru$key2.previous) {
                _previous = this.lru[key].previous;
                this.lru[_previous].next = this.lru[key].next;
              }
              _context4.next = 6;
              return localForage.removeItem(key);
            case 6:
              delete this.lru[key];
              this.size -= 1;
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function remove(_x4) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }]);
  return BrowserCache;
}();
var instance = new BrowserCache();
instance._init();
export default instance;